import { BonusSettlementsOverviewApi } from '../overview/api/bonus-settlements-overview-api';

export class BonusSettlementsApi {
    constructor(protected baseUrl: string) {
        this.BonusSettlementsOverview = new BonusSettlementsOverviewApi(this.baseUrl);
    }

    public BonusSettlementsOverview: BonusSettlementsOverviewApi;
}
